import { render, staticRenderFns } from "./TDeleteButton.vue?vue&type=template&id=1bcf424c&"
import script from "./TDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./TDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports